import { render, staticRenderFns } from "./CreateTable.vue?vue&type=template&id=fd8d286e&scoped=true"
import script from "./CreateTable.vue?vue&type=script&lang=js"
export * from "./CreateTable.vue?vue&type=script&lang=js"
import style0 from "./CreateTable.vue?vue&type=style&index=0&id=fd8d286e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8d286e",
  null
  
)

export default component.exports